const checkTabEmpty = (formID, candidateInfo, formConfiguration) => {
	// await this.getCandidateDetailCand();
	if (formID == "personalDetails") {
		return candidateInfo.dateOfBirth && candidateInfo.dateOfBirth != null;
	} else if (formID == "education") {
		return (
			candidateInfo.educationalInfo &&
			formConfiguration.education &&
			ifOriginalDataPresentCount(candidateInfo.educationalInfo).count >=
				formConfiguration.education.minimum &&
			ifOriginalDataPresent(candidateInfo.educationalInfo)
		);
	} else if (formID == "experience") {
		return (
			candidateInfo.experience &&
			formConfiguration.experience &&
			ifOriginalDataPresentCount(candidateInfo.experience).count >=
				formConfiguration.experience.minimum &&
			ifOriginalDataPresent(candidateInfo.experience)
		);
	} else if (formID == "skills") {
		return formConfiguration.skills &&
			formConfiguration.skills.minimum != null &&
			formConfiguration.interpersonalSkills &&
			formConfiguration.interpersonalSkills.minimum != null &&
			formConfiguration.hobbies &&
				formConfiguration.hobbies.minimum != null
			? candidateInfo.skills &&
					ifOriginalDataPresentCount(candidateInfo.skills).count >=
						formConfiguration.skills.minimum &&
					candidateInfo.interpersonalSkills &&
					ifOriginalDataPresentCount(candidateInfo.interpersonalSkills).count >=
						formConfiguration.interpersonalSkills.minimum && candidateInfo.hobbies &&
						candidateInfo.hobbies.length >= formConfiguration.hobbies.minimum
			: formConfiguration.skills &&
			  formConfiguration.skills.minimum != null 
			//   &&
			//   formConfiguration.interpersonalSkills &&
			//   formConfiguration.interpersonalSkills.minimum == null && formConfiguration.hobbies &&
			//   formConfiguration.hobbies.minimum == null
			? candidateInfo.skills &&
			  ifOriginalDataPresentCount(candidateInfo.skills).count >=
					formConfiguration.skills.minimum
			:
			  formConfiguration.interpersonalSkills &&
			  formConfiguration.interpersonalSkills.minimum != null 
			//   && formConfiguration.hobbies &&
			//   formConfiguration.hobbies.minimum == null && formConfiguration.skills &&
			//   formConfiguration.skills.minimum == null 
			? candidateInfo.interpersonalSkills &&
			  ifOriginalDataPresentCount(candidateInfo.interpersonalSkills).count >=
					formConfiguration.interpersonalSkills.minimum
			: 
			// formConfiguration.skills &&
			// formConfiguration.skills.minimum == null &&
			// formConfiguration.interpersonalSkills &&
			// formConfiguration.interpersonalSkills.minimum == null &&
			formConfiguration.hobbies &&
			formConfiguration.hobbies.minimum != null?
			candidateInfo.hobbies.length >= formConfiguration.hobbies.minimum:
			candidateInfo.skills &&
			  candidateInfo.interpersonalSkills &&
			  candidateInfo.hobbies &&
			  formConfiguration.skills &&
			  formConfiguration.interpersonalSkills &&
			  formConfiguration.hobbies &&
			  ifOriginalDataPresentCount(candidateInfo.skills).count +
					ifOriginalDataPresentCount(candidateInfo.interpersonalSkills).count + candidateInfo.hobbies.length >=
					formConfiguration.skills.minimum +
						formConfiguration.interpersonalSkills.minimum + formConfiguration.hobbies.minimum;
	} else if (formID == "project") {
		return (
			candidateInfo.projects &&
			formConfiguration.project &&
			ifOriginalDataPresentCount(candidateInfo.projects).count >=
				formConfiguration.project.minimum &&
			ifOriginalDataPresent(candidateInfo.projects)
		);
	} else if (formID == "achievement") {
		return (
			(candidateInfo.achievement &&
				ifOriginalDataPresent(candidateInfo.achievement)) ||
			(candidateInfo.awards && ifOriginalDataPresent(candidateInfo.awards)) ||
			(candidateInfo.events &&
				ifOriginalDataPresent(candidateInfo.events) &&
				formConfiguration.achievement &&
				formConfiguration.achievement.minimum != null &&
				ifOriginalDataPresentCount(candidateInfo.achievement).count +
					ifOriginalDataPresentCount(candidateInfo.awards).count +
					ifOriginalDataPresentCount(candidateInfo.events).count >=
					formConfiguration.achievement.minimum)
		);
	} else if (formID == "hobbies") {
		return (
			(candidateInfo.hobbies &&
				formConfiguration.hobbies &&
				formConfiguration.hobbies.minimum != null &&
				candidateInfo.hobbies.length >= formConfiguration.hobbies.minimum) ||
			(formConfiguration.hobbies &&
				formConfiguration.hobbies.minimum == null &&
				candidateInfo.hobbies.length > 0)
		);
	} else {
		return false;
	}
};

const ifOriginalDataPresent = (datas) => {
	return datas.some((obj) => obj.hasOwnProperty("priorityID"));
};

const ifOriginalDataPresentCount = (datas) => {
	let count = datas.reduce(
		(accumulator, obj) => {
			if (obj.hasOwnProperty("priorityID")) {
				accumulator.count++; // Increment count if object has "priorityID"
			}
			return accumulator;
		},
		{ count: 0 }
	); // Initialize accumulator with count property

	return {
		hasPriorityID: datas.some((obj) => obj.hasOwnProperty("priorityID")),
		count: count.count, // Return the count
	};
};

export { checkTabEmpty, ifOriginalDataPresent, ifOriginalDataPresentCount };
